import axios from 'axios';
import Vue from 'vue';

export default {
  state: {
    documentReviewAgentRunsByDocId: {},
  },
  actions: {
    async fetchDocumentReviewAgentRunsForDocId(context, documentId) {
      const res = await axios.get(
        `/api/v2/agents/runs?document_id=${documentId}`,
      );
      const runs = res.data.data ?? [];
      // Vue.set is required so that the reactivity system will update when
      // an object key changes
      Vue.set(context.state.documentReviewAgentRunsByDocId, documentId, runs);
    },
  },
  getters: {
    getDocumentReviewAgentRunsForDocId: (state) => (documentId) => {
      if (!documentId) {
        return undefined;
      }
      return state.documentReviewAgentRunsByDocId[documentId];
    },
  },
};
